/*
* Copyright (c) 2023 Eugenio Espinoza
*
* Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"),
* to use the Software solely for personal, non-commercial purposes. Any commercial use, distribution, sublicense, sale, or modification of the Software
* is strictly prohibited without the explicit written permission of the copyright holder.
*
* For licensing inquiries, please contact Eugenio Espinoza at mail.eugenioespinoza.com .
*
* THE SOFTWARE IS PROVIDED "AS IS," WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
* FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
* WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/

import '../App.css';
import Footer from '../containers/Footer/Footer';
import React from 'react';
import HomeSection from '../containers/Hero/HomeSection';
import ProcessSection from '../containers/Proccess/ProcessSection';
import AboutSection from '../containers/About/AboutSection';
import ProjectsSection from '../containers/Projects/ProjectsSection';
import GallerySection from '../containers/Gallery/GallerySection';
import ContactSection from '../containers/Contact/ContactSection';


function Home() {
  return (
    <div>
      <HomeSection />
      <ProcessSection />
      <AboutSection />
      <ProjectsSection />
      {/* Owner-managed photos. Renders nothing until he has published one. */}
      <GallerySection />
      <ContactSection />
      <Footer />
    </div>
  );
}
  
export default Home;
